import affirm from '../core/Affirm'

class CSVManagerClass {
    escapeValue = (value: string): string => {
        if (value == null) {
            return ''
        }
        const sanitizedText = '"' + value.replace(/"/g, '""') + '"'
        return sanitizedText
    }

    formatValue = (value: any): string => {
        if (value == null) {
            return ''
        }
        switch (typeof value) {
            case 'object': {
                if (Array.isArray(value)) {
                    return value.map(v => this.escapeValue(v)).join('; ')
                } else {
                    return JSON.stringify(value)
                }
            }
            case 'string':
                return value
            default:
                return value.toString()
        }
    }

    convertToCSV = (data: any[][], headers?: string[]): string => {
        const columnDelimiter = ','
        const lineDelimiter = '\n'
        let result = ''

        if (data.length === 0) {
            return ''
        }

        if (headers && headers.length > 0) {
            result += headers.map(header => this.escapeValue(header)).join(columnDelimiter)
            result += lineDelimiter
        }

        data.forEach(row => {
            const rowResult = row
                .map(cell => this.escapeValue(this.formatValue(cell)))
                .join(columnDelimiter)
            result += rowResult + lineDelimiter
        })

        return result
    }

    downloadCSV = (data: any[][], headers?: string[], filename: string = 'sheet') => {
        const csvData = this.convertToCSV(data, headers)
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')

        link.setAttribute('href', url)
        link.setAttribute('download', filename + '.csv')
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    downloadCSVWithoutConversion = (fileUrl: string, filename: string = 'sheet') => {
        affirm(fileUrl, 'Missing the url to download the file from')
        const link = document.createElement('a')

        link.setAttribute('href', fileUrl)
        link.setAttribute('download', filename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    stripFieldFromData = <T>(data: T[][], fields: string[]): T[][] => {
        if (!data || data.length <= 0 || fields.length <= 0) return []
        if (Array.isArray(data[0])) {
            return data.map(innerArray => {
                const parsedFields = fields.map(el => Number(el))
                return innerArray.filter((_, index) => !parsedFields.includes(index))
            })
        }
    }

    stripFieldFromHeaders = <T extends string>(headers: T[], fields: string[]): T[] => {
        if (!headers || headers.length <= 0 || fields.length <= 0) return []
        return headers.filter(item => !fields.includes(String(item)))
    }
}

const CSVManager = new CSVManagerClass()
export default CSVManager
